import axios from 'axios';

import { apiPost, apiGet } from './helpers';

const getApiUploadDetails = (file) => {
    return apiGet('/attachments/new', {
        params: { filename: file.name },
    }).then((response) => response.data.attachment);
};

const uploadFileByURL = (uploadURL, file) => {
    return axios.put(
        uploadURL,
        file,
        {
            headers: {
                'Content-Type': file.type,
            },
        },
    );
};

const uploadFile = (file) => {
    return getApiUploadDetails(file)
        .then((uploadDetails) => uploadFileByURL(uploadDetails.upload_url, file)
            .then(() => uploadDetails));
};

const createAttachment = (attachmentData) => {
    return apiPost('/attachments', { attachment: attachmentData })
        .then((response) => response.data.attachment);
};

const uploadAndCreateAttachment = ({ file, ...attachmentData }) => {
    return uploadFile(file).then((uploadDetails) => {
        const attachmentPayload = {
            ...attachmentData,
            s3_key_uuid: uploadDetails.s3_key_uuid,
        };
        return createAttachment(attachmentPayload);
    });
};

export {
    uploadFile,
    createAttachment,
    uploadAndCreateAttachment,
};
